if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (this.submitButton.dataset.flavorJsguard === 'true') {
          this.submitButton.removeAttribute('disabled');
          delete this.submitButton.dataset.flavorJsguard;
        }

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        let sectionsToRender = [];
        if (this.cart) {
          sectionsToRender = this.cart.getSectionsToRender().map((section) => section.id);
          formData.append('sections', sectionsToRender);
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        for (const key of [...formData.keys()]) {
          if (/^properties\[/.test(key) && !formData.get(key)) formData.delete(key);
        }
        config.body = formData;

        // Collect all flavor group inputs scoped to this form (single: properties[flavors], multi: properties[flavors_*])
        // Uses input.form (DOM reference) instead of ID string matching to avoid CSS selector escaping issues.
        const flavorInputs = this.form
          ? [...document.querySelectorAll('input[name^="properties[flavors"]')]
              .filter(input => input.form === this.form)
          : [];

        if (flavorInputs.length > 0) {
          // Validate every group has at least one selection
          const emptyGroups = flavorInputs.filter(input => {
            try { return JSON.parse(input.value).length === 0; } catch(e) { return true; }
          });

          if (emptyGroups.length > 0) {
            const missingLabels = emptyGroups
              .map(input => input.dataset.groupLabel)
              .filter(Boolean);
            const msg = missingLabels.length > 0
              ? `Please select flavors for: ${missingLabels.join(' and ')}.`
              : 'Please select at least one flavor.';
            alert(msg);
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            return;
          }

          const uniqueGroupId = `PACK_${Date.now()}`;
          const mainProductProperties = { '_group_id': uniqueGroupId };
          // Carry over any non-flavor properties from the form (e.g. Custom Message)
          for (const [key, value] of formData.entries()) {
            const match = key.match(/^properties\[(.+)\]$/);
            if (match && !match[1].startsWith('flavors') && value.trim() !== '') {
              mainProductProperties[match[1]] = value;
            }
          }
          let totalPremiumQty = 0;
          let totalDeluxeQty = 0;

          flavorInputs.forEach(input => {
            const flavors = JSON.parse(input.value);
            // Derive group key from input name: "properties[flavors_cookies]" -> "cookies"
            // "properties[flavors]" -> null (single group, use generic keys)
            const nameMatch = input.name.match(/properties\[flavors_?([^\]]*)\]/);
            const groupKey = nameMatch && nameMatch[1] ? nameMatch[1] : null;

            flavors.forEach((flavor, i) => {
              const propKey = groupKey ? `${groupKey}_${i + 1}` : `flavor_${i + 1}`;
              mainProductProperties[propKey] = `${flavor.name}, qty: ${flavor.quantity}`;
              if (flavor.premium) totalPremiumQty += parseInt(flavor.quantity);
              if (flavor.deluxe) totalDeluxeQty += parseInt(flavor.quantity);
            });
          });

          const itemsToAdd = [{
            id: formData.get('id'),
            quantity: formData.get('quantity') || 1,
            properties: mainProductProperties
          }];

          if (totalPremiumQty > 0) {
            itemsToAdd.push({
              id: "52211565887787",
              quantity: totalPremiumQty,
              properties: { '_group_id': uniqueGroupId }
            });
          }

          if (totalDeluxeQty > 0) {
            itemsToAdd.push({
              id: "53609996517675",
              quantity: totalDeluxeQty,
              properties: { '_group_id': uniqueGroupId }
            });
          }

          if (sectionsToRender.length === 0) {
            sectionsToRender = ['cart-drawer', 'cart-icon-bubble', 'cart-notification-product'];
          }

          config.headers = {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          };

          config.body = JSON.stringify({
            items: itemsToAdd,
            sections: sectionsToRender,
            sections_url: window.location.pathname
          });
        }

        const fetchUrl = routes.cart_add_url.includes('.js') ? routes.cart_add_url : `${routes.cart_add_url}.js`;

        fetch(fetchUrl, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
              
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = text;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
